/**
 * Orders Header Component
 */

import { PageHeader } from '@ufc/uikit'
import { Download } from '@ufc/uikit'
import { useTranslation } from '@ufc/core'
import type { OrdersHeaderProps } from '../types'

export function OrdersHeader({
  isRTL,
  onExport,
}: OrdersHeaderProps) {
  const { t } = useTranslation()

  return (
    <PageHeader
      title={t('orders.title')}
      subtitle={t('orders.subtitle')}
      isRTL={isRTL}
      actions={[
        {
          label: t('common.export'),
          icon: Download,
          onClick: onExport,
          variant: 'outline',
        },
      ]}
    />
  )
}
